// Whether a typed email could be an address at all: one @, a dot in the domain, nothing an address
// cannot hold. The checkout used to test /.+@.+\..+/, and only on a sell-only order, so
// "name@mail;.com" and a name with no @ were stored, and Shopify then refused the forwarded order
// (Area-Sync #386, two orders, 675 refused attempts). This also catches what would bounce the
// customer's copy of the order. It does not try to prove an address is real.
const EMAIL_SHAPE = /^[^\s@;,:<>()[\]"]+@[^\s@;,:<>()[\]"]+\.[^\s@;,:<>()[\]".]{2,}$/;

export function looksLikeAnEmail(value) {
    return EMAIL_SHAPE.test(String(value || '').trim());
}
